import { orange } from '@mui/material/colors';
import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  dashboardInternal: {
    minHeight: 416,
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(2)
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginRight: theme.spacing(2)
  },
  text: {
    color: theme.vars.palette.text.primary,
    paddingTop: theme.spacing(1)
  },
  quickSearch: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '20%',
    height: 70,
    minWidth: 300
  },
  ticketsTableHeaderContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: theme.vars.palette.background.elevation1,
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  ticketsTableContainer: {
    marginTop: theme.spacing(2),
    backgroundColor: theme.vars.palette.background.elevation2,
    overflow: 'hidden',
    minHeight: 500,
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  ticketsTable: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    flex: 1,
    borderTop: `solid 1px ${theme.vars.palette.border.light}`,
    '& .MuiTablePagination-root': {
      overflow: 'hidden'
    }
  },
  teamQueueTicketsTable: {
    width: '100%',
    height: 515,
    '& .MuiDataGrid-cell': {
      fontSize: '1.1rem',
      paddingTop: '0!important'
    },
    '& .MuiDataGrid-filler': {
      display: 'none'
    },
    '& .MuiDataGrid-scrollbar--vertical': {
      display: 'none'
    },
    '& .riskyTickets': {
      color: theme.vars.palette.error.main,
      fontWeight: 'bold'
    },
    '& .openTickets': {
      color: theme.vars.palette.info.main,
      fontWeight: 'bold'
    },
    '& .nextActionOwnerTickets': {
      color: '#9ACD32',
      fontWeight: 'bold'
    },
    '& .dueNowTickets': {
      color: orange[300],
      fontWeight: 'bold'
    },
    '& .pastDueTickets': {
      color: theme.vars.palette.warning.main,
      fontWeight: 'bold'
    }
  }
}));

export default useStyles;
